import ApiService from "@/api/baseApi/api-service";
import { Config } from "../../config";
import {
  IGetCart,
  ISubmitCheckoutResponse,
} from "../cart/interfaces/cart-interfaces";
import {
  ICheckToken,
  IGetAllOrders,
  IGetAllOrdersParams,
  IGetOrderDetails,
  IGetPaymentLink,
} from "./interfaces/order-interfaces";
import { IResultStamp } from "../../common-interfaces/IResultStamp";

const URLs = {
  getAllOrders: "/orders",
  getOrderDetails: "/orders/",
  checkToken: "check-token",
};
class ApiOrder extends ApiService {
  constructor(config: Config) {
    super({ ...config });
  }
  getAllOrders = (params: IGetAllOrdersParams): Promise<IGetAllOrders> =>
    this.get(URLs.getAllOrders, { params });
  getOrderDetails = (id: number): Promise<IGetOrderDetails> =>
    this.get(URLs.getOrderDetails + id, {});
  reorder = (id: number): Promise<IGetCart> =>
    this.post(`orders/${id}/reorder`, {});
  cancelOrder = (id: number): Promise<IGetCart> =>
    this.post(`orders/${id}/cancel`, {});
  getPaymentLink = (id: number): Promise<IGetPaymentLink> =>
    this.get(`orders/${id}/payment-link`, {});
  pay = ({
    order_id,
    gateway_id,
    gateway_account_id,
  }: {
    order_id: number;
    gateway_id: number;
    gateway_account_id: number;
  }): Promise<ISubmitCheckoutResponse> =>
    this.post(`orders/${order_id}/pay`, { gateway_id, gateway_account_id });
  checkToken = (token: string): Promise<ICheckToken> =>
    this.get(URLs.checkToken, { params: { token } });
  confirmCod = ({
    order_id,
    status,
  }: {
    order_id: number;
    status: "confirmed" | "canceled";
  }): Promise<IResultStamp> =>
    this.post(`orders/${order_id}/confirm-cod`, { status });
}
export default ApiOrder;
